import {createReducer} from '@reduxjs/toolkit';
import {setView} from '../../actions/map.js';
import {DEFAULT_EXTENT} from '../../constants.js';

export default createReducer(DEFAULT_EXTENT, builder => {
  builder.addCase(setView, (state, {payload}) => payload.extent || state);
});
